import { render, staticRenderFns } from "./DiagramThumbnail.vue?vue&type=template&id=561dc467&scoped=true&"
import script from "./DiagramThumbnail.vue?vue&type=script&lang=js&"
export * from "./DiagramThumbnail.vue?vue&type=script&lang=js&"
import style0 from "./DiagramThumbnail.vue?vue&type=style&index=0&id=561dc467&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561dc467",
  null
  
)

export default component.exports